import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => (
  <div className="login-page">
    <div className="login-container">
      <div className="login-welcome">
        <h1>Welcome to HealthFlow</h1>
        <p>Track your health journey with our comprehensive health management platform.</p>
        <ul className="features-list">
          <li>Personal Health Dashboard</li>
          <li>Medication Tracking</li>
          <li>Symptom Monitoring</li>
          <li>AI-Powered Health Insights</li>
        </ul>
      </div>

      <div className="login-form-container">
        <div className="login-form">
          <h2>Get Started Today</h2>
          <p className="login-subtitle">Join thousands of users managing their health journey</p>

          <Link to="/login" className="login-button">
            Sign In
          </Link>

          <div className="divider">
            <span>or</span>
          </div>

          <Link to="/register" className="login-button" style={{ backgroundColor: 'var(--success-color)' }}>
            Create Account
          </Link>

          <div className="features-preview">
            <h3>Why Choose HealthFlow?</h3>
            <ul className="features-list" style={{ marginTop: '1rem' }}>
              <li>Personalized Health Insights</li>
              <li>Easy Medication Management</li>
              <li>Real-time Health Tracking</li>
              <li>Secure & Private Platform</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;
